// The values in this enum may not follow convention
// because they are defined by an external service or library
export enum MessageAttachmentType {
  APPLICATION_PDF = 'application/pdf',
  APPLICATION_OCTET_STREAM = 'application/octet-stream',
  FORM = 'form',
  IMAGE_JPG = 'image/jpg',
  IMAGE_JPEG = 'image/jpeg',
  IMAGE_PNG = 'image/png',
  IMAGE_BMP = 'image/bmp',
  IMAGE_GIF = 'image/gif',
  STORY_MENTION = 'story mention',
  VIDEO_3GPP = 'video/3gpp',
  VIDEO_MP4 = 'video/mp4',
  VIDEO_MPEG = 'video/mpeg',
  VIDEO_OGG = 'video/ogg',
  VIDEO_QUICKTIME = 'video/quicktime',
  VIDEO_WEBM = 'video/webm',
  VIDEO_XM4V = 'video/x-m4v',
  VIDEO_MSASF = 'video/ms-asf',
  VIDEO_XMSVIDEO = 'video/x-msvideo',
  VIDEO_XMSWMV = 'video/x-ms-wmv',
  VCARD = 'text/x-vcard',
}
